import { ConfigProvider, theme } from "antd";
import { useTheme } from "next-themes";
import { Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import ViewerPage from "./components/common/ViewerPage";
import HeaderPage from "./components/Header";
import { useAuth } from "./context/AuthContext";
import ChangeDirectRoute from "./lib/ChangeDirectRoute";
import AdminCourses from "./pages/Admin/AdminCourses";
import AdminDashboardDemo from "./pages/Admin/AdminDashboardDemo";
import AdminOverview from "./pages/Admin/AdminOverview";
import AdminRoot from "./pages/Admin/AdminRoot";
import AdminCategories from "./pages/Admin/Category/AdminCategories";
import AdminViewCategory from "./pages/Admin/Category/AdminViewCategory";
import AdminViewCourses from "./pages/Admin/Course/AdminViewCourses";
import AdminViewSubCategory from "./pages/Admin/SubCategory/AdminViewSubCategory";
import AdminAllTeachers from "./pages/Admin/Teachers/AdminAllTeachers";
import AdminTeachers from "./pages/Admin/Teachers/AdminTeachers";
import ForgetPasswordPage from "./pages/Auth/ForgetPassword";
import LoginPage from "./pages/Auth/Login";
import RegisterPage from "./pages/Auth/Register";
import ResetPasswordPage from "./pages/Auth/ResetPasssword";
import AllLessons from "./pages/Teacher/Lesson/AllLessons";
import ShowHomeworkAnswer from "./pages/Teacher/Lesson/Tabs/HomeWork/ShowHomeworkAnswer";
import AddQuiz from "./pages/Teacher/Lesson/Tabs/Quiz/AddQuiz";
import EditQuiz from "./pages/Teacher/Lesson/Tabs/Quiz/EditQuiz";
import ShowQuizAnswer from "./pages/Teacher/Lesson/Tabs/Quiz/ShowQuizAnswer";
import ViewLesson from "./pages/Teacher/Lesson/ViewLesson";
import TeacherCourses from "./pages/Teacher/Pages/TeacherCourses";
import TeacherStudents from "./pages/Teacher/Pages/Students/TeacherStudents";
import TeacherRoot from "./pages/Teacher/Pages/_components/TeacherRoot";
import UserCourses from "./pages/User/MyCourses/UserCourses";
import UserDashboard from "./pages/User/UserDashboard";
import UserRoot from "./pages/User/UserRoot";
import UserSettings from "./pages/User/UserSettings";
import TeacherPrices from "./pages/Teacher/Pages/Prices/TeacherPrices";
import TeacherScheduler from "./pages/Teacher/Pages/Availability/TeacherAvailability";
import CoursesPage from "./pages/User/AllCourses/CoursesPage";
import TeacherAssignments from "./pages/Teacher/Pages/HomeWork/TeacherAssignments";
import TeacherQuizez from "./pages/Teacher/Pages/Quizez/TeacherQuizez";
import GradebookPage from "./pages/Teacher/Pages/Gradebook/GradebookPage";
import LoaderPage from "./components/LoaderPage";
import UserQuizzes from "./pages/User/Quiz/UserQuizzes";
import UserQuizExam from "./pages/User/Quiz/UserQuizExam";
import PromoCodePage from "./pages/PromoCode/PromoCodePage";
import CourseDetails from "./pages/User/MyCourses/CourseDetails";
import StudentLessonsTable from "./pages/User/AllLessons/Lessons";
import Invoices from "./pages/Teacher/Pages/Invoices/Invoices";
import Schedule from "./pages/User/Schedule/Schedule";
import TeacherSettings from "./pages/Teacher/Pages/Settings/TeacherSettings";
import NotificationsPage from "./pages/Notifications/NotificationsPage";
import SalaryPage from "./pages/Teacher/Pages/Salary/SalaryPage";
import TransactionsPage from "./pages/Teacher/Pages/Transactions/TransactionsPage";
import UsersPage from "./pages/Admin/Users/UsersPage";
import FAQPage from "./pages/Admin/FAQ/FAQPage";
import PaymentMethodsPage from "./pages/Teacher/Pages/PaymentMethods/PaymentMethodsPage";
import SurveysPage from "./pages/Admin/Surveys/SurveysPage";
import AddSurvey from "./pages/Admin/Surveys/_components/AddSurvey";
import EditSurvey from "./pages/Admin/Surveys/_components/EditSurvey";
import SiteSettings from "./pages/Admin/Settings/SiteSettings";
import ChatPage from "./pages/Chat/ChatPage";
import MainHome from "./pages/InterFace/MainHome";
import MainCourses from "./pages/InterFace/MainCourses";
import MainRoot from "./pages/InterFace/MainRoot";
import MainCourseDetails from "./pages/InterFace/MainCourseDetails";
import { useLanguage } from "./context/LanguageContext";
import MainFAQ from "./pages/InterFace/MainFAQ";
import MainTeachers from "./pages/InterFace/MainTeachers";
import MainTeacherInfo from "./pages/InterFace/MainTeacherInfo";
import MainContactUs from "./pages/InterFace/MainContactUs";
import MainStuRate from "./pages/InterFace/MainStuRate";
import MainJobOffer from "./pages/InterFace/MainJobOffer";
import MainAboutUs from "./pages/InterFace/MainAboutUs";
import MainFindJob from "./pages/InterFace/MainFindJob";
import MainSurvay from "./pages/InterFace/MainSurvay";

function App() {
  const { language } = useLanguage();
  const { token, loading } = useAuth();
  const { theme: currentTheme, systemTheme } = useTheme();
  const isDarkMode =
    currentTheme === "dark" ||
    (currentTheme === "system" && systemTheme === "dark");

  if (loading) {
    return <LoaderPage title={"Loading Data"} />;
  }

  return (
    <div >
      <ConfigProvider
        theme={{
          algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
          token: {
            colorPrimary: "#2563eb",
            borderRadius: 8,
            colorBgContainer: "hsl(var(--background))",
            colorText: "hsl(var(--primary))",
            colorBgElevated: "hsl(var(--background))",
            colorBorder: "hsl(var(--border))",
          },
        }}
      >
        <Routes>
          <Route element={<MainRoot />}>
            <Route path="/" element={<MainHome />} />
            <Route path="/courses" element={<MainCourses />} />
            <Route path="/course-info" element={<MainCourseDetails />} />
            <Route path="/faq" element={<MainFAQ />} />
            <Route path="/teachers" element={<MainTeachers />} />
            <Route path="/teacher-info" element={<MainTeacherInfo />} />
            <Route path="/contact-us" element={<MainContactUs />} />
            <Route path="/students-rates" element={<MainStuRate />} />
            <Route path="/about-us" element={<MainAboutUs />} />
            <Route path="/job-offer" element={<MainJobOffer />} />
            <Route path="/find-job" element={<MainFindJob />} />
            <Route path="/survays" element={<MainSurvay />} />
          </Route>
          <Route element={<MainRoot />}>
            <Route element={<ChangeDirectRoute auth={!!!token} />}>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgetPassword" element={<ForgetPasswordPage />} />
              <Route path="/resetPassword" element={<ResetPasswordPage />} />
            </Route>
          </Route>

          {/* Admin */}
          <Route element={<ChangeDirectRoute auth={!!token} to="/login" />}>
            <Route element={<AdminRoot />}>
              <Route path="/admin/overview" element={<AdminOverview />} />
              <Route path="/admin/users" element={<UsersPage />} />
              <Route path="/admin/teachers" element={<AdminTeachers />} />
              <Route
                path="/admin/all-teachers"
                element={<AdminAllTeachers />}
              />
              <Route
                path="/admin/teacher-settings"
                element={<TeacherSettings />}
              />
              <Route path="/admin/settings" element={<UserSettings />} />
              <Route path="/admin/categories" element={<AdminCategories />} />
              <Route
                path="/admin/category-view/:id"
                element={<AdminViewCategory />}
              />
              <Route
                path="/admin/sub-category-view/:id"
                element={<AdminViewSubCategory />}
              />
              <Route
                path="/admin/course-view/:id"
                element={<AdminViewCourses />}
              />
              <Route path="/admin/lessons/:id" element={<AllLessons />} />
              <Route path="/admin/lesson-view/:id" element={<ViewLesson />} />
              <Route path="/admin/courses" element={<AdminCourses />} />
              <Route path="/admin/gradebook" element={<GradebookPage />} />
              <Route path="/admin/promo-code" element={<PromoCodePage />} />
              <Route path="/admin/FAQ" element={<FAQPage />} />
              <Route
                path="/admin/payment-methods"
                element={<PaymentMethodsPage />}
              />
              <Route path="/admin/salary" element={<SalaryPage />} />
              <Route
                path="/admin/transactions"
                element={<TransactionsPage />}
              />
              <Route path="/admin/surveys" element={<SurveysPage />} />
              <Route path="/admin/add-survey" element={<AddSurvey />} />
              <Route path="/admin/edit-survey" element={<EditSurvey />} />
              <Route path="/admin/site-settings" element={<SiteSettings />} />
              <Route path="/admin/chats" element={<ChatPage />} />
              <Route
                path="/admin/dashboard-demo"
                element={<AdminDashboardDemo />}
              />
              <Route
                path="/admin/notifications"
                element={<NotificationsPage />}
              />
            </Route>
          </Route>

          {/* User */}
          <Route element={<ChangeDirectRoute auth={!!token} to="/login" />}>
            <Route element={<UserRoot />}>
              <Route path="/dashboard" element={<UserDashboard />} />
              <Route path="/all-courses" element={<CoursesPage />} />
              <Route path="/my-courses/:courseType" element={<UserCourses />} />
              <Route path="/course-details" element={<CourseDetails />} />
              <Route path="/lesson-view/:id" element={<ViewLesson />} />
              <Route path="/lessons" element={<StudentLessonsTable />} />
              <Route path="/quizzes" element={<UserQuizzes />} />
              <Route path="/quiz-exam" element={<UserQuizExam />} />
              <Route path="/assignments" element={<TeacherAssignments />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/settings" element={<UserSettings />} />
              <Route path="/teacher-settings" element={<TeacherSettings />} />
              <Route path="/notifications" element={<NotificationsPage />} />
            </Route>
          </Route>

          {/* Teacher */}
          <Route element={<ChangeDirectRoute auth={!!token} to="/login" />}>
            <Route element={<TeacherRoot />}>
              <Route
                path="/teacher/notifications"
                element={<NotificationsPage />}
              />
              <Route path="/teacher/courses" element={<TeacherCourses />} />
              <Route
                path="/teacher/availability"
                element={<TeacherScheduler />}
              />
              <Route path="/teacher/prices" element={<TeacherPrices />} />
              <Route
                path="/teacher/assignments"
                element={<TeacherAssignments />}
              />
              <Route path="/teacher/quizez" element={<TeacherQuizez />} />
              <Route path="/teacher/students" element={<TeacherStudents />} />
              <Route path="/teacher/gradebook" element={<GradebookPage />} />
              <Route
                path="/teacher/course-view/:id"
                element={<AdminViewCourses />}
              />
              <Route path="/teacher/lessons/:id" element={<AllLessons />} />
              <Route path="/teacher/lesson-view/:id" element={<ViewLesson />} />
              <Route path="/teacher/add-quiz/:id" element={<AddQuiz />} />
              <Route path="/teacher/edit-quiz/:bid" element={<EditQuiz />} />
              <Route
                path="/teacher/show-quiz-answers/:id"
                element={<ShowQuizAnswer />}
              />
              <Route
                path="/teacher/show-homework-answers/:id"
                element={<ShowHomeworkAnswer />}
              />
              <Route path="/teacher/promo-code" element={<PromoCodePage />} />
              <Route
                path="/teacher/teacher-settings"
                element={<TeacherSettings />}
              />
              <Route path="/teacher/settings" element={<UserSettings />} />
              <Route path="/teacher/salary" element={<SalaryPage />} />
              <Route
                path="/teacher/transactions"
                element={<TransactionsPage />}
              />
            </Route>
          </Route>
          {/* other routes */}
          <Route path="/view" element={<ViewerPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
        </Routes>
        <Toaster />
      </ConfigProvider>
    </div>
  );
}

export default App;
